import { useState } from "react";
import { Card, Form, Input, Button, Tabs, Typography, Divider } from "antd";
import { UserOutlined, LockOutlined, SmileOutlined } from "@ant-design/icons";
import { useLogin, useRegister } from "../hooks/useAuth";
import { useAuthStore } from "../stores/authStore";
import { Navigate } from "react-router-dom";

const { Title, Text } = Typography;

export default function Login() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [tab, setTab] = useState<"login" | "register">("login");
  const loginMutation = useLogin();
  const registerMutation = useRegister();
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleLogin = async (values: {
    username: string;
    password: string;
  }) => {
    loginMutation.mutate(values);
  };

  const handleRegister = async (values: {
    username: string;
    password: string;
    display_name: string;
  }) => {
    registerMutation.mutate(values);
  };

  const loginFormContent = (
    <Form
      form={loginForm}
      layout="vertical"
      onFinish={handleLogin}
      autoComplete="off"
    >
      <Form.Item
        name="username"
        label="用户名"
        rules={[{ required: true, message: "请输入用户名" }]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="输入用户名"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="密码"
        rules={[{ required: true, message: "请输入密码" }]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="输入密码"
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          loading={loginMutation.isPending}
        >
          登录
        </Button>
      </Form.Item>
    </Form>
  );

  const registerFormContent = (
    <Form
      form={registerForm}
      layout="vertical"
      onFinish={handleRegister}
      autoComplete="off"
    >
      <Form.Item
        name="username"
        label="用户名"
        rules={[
          { required: true, message: "请输入用户名" },
          { min: 3, message: "至少 3 个字符" },
          { pattern: /^[a-zA-Z0-9_]+$/, message: "只能包含字母、数字和下划线" },
        ]}
      >
        <Input
          prefix={<UserOutlined />}
          placeholder="3-50位字母/数字/下划线"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="display_name"
        label="显示名称"
        rules={[{ required: true, message: "请输入显示名称" }]}
      >
        <Input
          prefix={<SmileOutlined />}
          placeholder="你在平台上的显示名称"
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="password"
        label="密码"
        rules={[
          { required: true, message: "请输入密码" },
          { min: 6, message: "至少 6 个字符" },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined />}
          placeholder="至少6位密码"
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          loading={registerMutation.isPending}
        >
          注册
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: 24,
      }}
    >
      <Card
        style={{
          width: 420,
          borderRadius: 12,
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
        }}
        bodyStyle={{ padding: "32px 32px 16px" }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Title level={3} style={{ margin: 0 }}>
            AI IoT 智能家居
          </Title>
          <Text type="secondary">登录以管理您的智能设备</Text>
        </div>

        <Tabs
          activeKey={tab}
          onChange={(key) => setTab(key as "login" | "register")}
          centered
          items={[
            { key: "login", label: "登录", children: loginFormContent },
            { key: "register", label: "注册", children: registerFormContent },
          ]}
        />

        <Divider style={{ margin: "12px 0" }} />
        <div style={{ textAlign: "center" }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            使用设备 API Key 的已有连接不受影响
          </Text>
        </div>
      </Card>
    </div>
  );
}
